import { Controller } from "@hotwired/stimulus"
import Phone from '../src/shared/phone';

// Connects to data-controller="phone-or-email-mask"
export default class extends Controller {
  connect() {
    this.element.addEventListener('blur', () => this.applyMask())
    this.applyMask() // apply mask on load
  }

  applyMask() {
    if (this.element.value.length > 0) {
      const digits = this.element.value.replace(/\D/g, '');
      if (digits.length === 11) {
        this.element.value = Phone.applyMask(digits);
      }
    }
  }
}
